export const ImportedSVGs = {};
export const ImportedJPGs = {};
export const LoadedImages = {};

export const assetDefaultLocation = "https://assets.nicoandbyrne.com/nbcom/graphics/";

export const imgURL = (name) => {
    return (`${assetDefaultLocation}${name}`);
}

export const loadImage = async (name) => {
    if(!LoadedImages[name]) {
        const imgLoading = {};

        const importer = async () => {
            try {
                imgLoading.current = (
                    await import(`${assetDefaultLocation}${name}`)
                )
            } catch (err) {
                console.log(err);
            } finally {
                //TODO: something in the finally...
            }
        }

        await importer();

        const ImpGraphic = imgLoading.current;

        LoadedImages[name] = ImpGraphic;

        return (
            ImpGraphic
        )
    }

    return(LoadedImages[name]);
}

export const svgImport = async (name) => {
    if(!ImportedSVGs[name]) {
        const svgImport = {}; // = useRef();

        const importer = async () => {
            try {
                svgImport.current = (
                    await import(`../graphics/svg/${name}.svg`)
                )
            } catch (err) {
                console.log(err);
            } finally {
                //TODO: something here?
            }
        }
        await importer();

        const SvgGraphic = svgImport.current;

        ImportedSVGs[name] = SvgGraphic;

        console.log("here", SvgGraphic);
        
        return (
            SvgGraphic
        )
    }

    return (ImportedSVGs[name]);
    
}

export const jpgImport = async (name) => {
    if(!ImportedJPGs[name]) {
        const jpgImport = {}; // = useRef();

        const importer = async () => {
            try {
                jpgImport.current = (
                    await import(`../graphics/jpg/${name}.jpg`)
                )
            } catch (err) {
                console.log(err);
            } finally {
                //TODO: something here?
            }
        }
        await importer();

        const JpgGraphic = jpgImport.current;

        ImportedJPGs[name] = JpgGraphic;

        console.log("here", JpgGraphic);
        
        return (
            JpgGraphic
        )
    }

    return (ImportedJPGs[name]);
    
}